module.exports = __webpack_public_path__ + "img/home-city.597bcea2.png";